import React from 'react'
import type { ComparisonFeature, ComparisonLandingCopy, CompetitorGap } from './landingContent'

type ComparisonSectionProps = {
  copy: ComparisonLandingCopy
  features: ComparisonFeature[]
  gaps: CompetitorGap[]
}

const statusClassName = (value: string) => {
  const normalized = value.toLowerCase()

  if (
    normalized.includes('yes') ||
    normalized.includes('نعم') ||
    normalized.includes('أصلي') ||
    normalized.includes('قوي') ||
    normalized.includes('native') ||
    normalized.includes('strong') ||
    normalized.includes('designed')
  ) {
    return 'landing-comparison__status landing-comparison__status--yes'
  }

  if (normalized.includes('no') || normalized.includes('لا')) {
    return 'landing-comparison__status landing-comparison__status--no'
  }

  return 'landing-comparison__status landing-comparison__status--partial'
}

export const ComparisonSection: React.FC<ComparisonSectionProps> = ({ copy, features, gaps }) => {
  return (
    <section className="landing-section landing-section--muted" id="comparison">
      <div className="container stack-lg">
        <div className="landing-section-heading">
          <p className="landing-eyebrow">{copy.eyebrow}</p>
          <h2>{copy.title}</h2>
          <p>{copy.copy}</p>
        </div>

        <div className="landing-comparison-wrap" role="region" aria-label={copy.title} tabIndex={0}>
          <table className="landing-comparison-table">
            <thead>
              <tr>
                <th>{copy.featureColumn}</th>
                {copy.vendors.map((vendor) => (
                  <th key={vendor}>{vendor}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {features.map((feature) => (
                <tr key={feature.feature}>
                  <th scope="row">{feature.feature}</th>
                  {feature.values.map((value, index) => (
                    <td key={`${feature.feature}-${index}`}>
                      <span className={statusClassName(value)}>{value}</span>
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="landing-gap-grid">
          {gaps.map((gap) => (
            <article className="landing-gap-card" key={gap.vendor}>
              <h3>{gap.vendor}</h3>
              <p>{gap.has}</p>
              <span>{gap.nexusGap}</span>
            </article>
          ))}
        </div>

        <p className="landing-comparison-note">{copy.note}</p>
      </div>
    </section>
  )
}
